import React, { useCallback, useState, useRef, useEffect } from 'react';
import { useHistory, Link } from "react-router-dom";
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import AccordionReact from 'devextreme-react/accordion';
import FormField from '../../../../../dynamicFormBuilder/FormField'
import { GridLayout } from "../../../../../common/GridLayout";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import data from "../../../../../assets/apiRoutes.json";
import Toolbar, { Item } from "devextreme-react/toolbar";
import {
    Column,
    DataGrid,
    GroupPanel,
    Scrolling,
    Grouping,
    FilterRow,
    HeaderFilter,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar as GridToolbar,
    Item as GridToolbarItem,
  Export,
  Pager,
  ColumnChooser,
  ColumnChooserSearch,
  StateStoring,
  Editing,
} from "devextreme-react/data-grid";
import { FillFilters, FormatPhoneNumber, GetFormatedDateWithTime, loadLookupFromDataSource } from '../../../../../common/Utils'
import { LotSublotHeaderLayout, SearchLayout } from '../Layout';
import GridLayoutManager from "../../../../../gridLayoutCustomization/GridLayoutManager";
import { alert } from 'devextreme/ui/dialog';
import { ItemTypes } from '../../../../../enum/Enum';
import { MESSAGES } from '../../../../../common/Messages';

const searchpanel = [
    {
        ID: 1,
        Title: 'Search Filters'
    }
];


const LotsSublotForShipment = (props) => {
    const history = useHistory();
    var accessToken = props.oidc.user.access_token;
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const formRefs = useRef({});
    const [selectedItems, setSelectedItems] = useState([searchpanel[0]]);
    const [searchPanelStatus, setSearchPanelStatus] = useState(true);
    const [selectedRows, setSelectedRows] = useState(null);
    const rowId = useRef(null);
    const dataGrid = useRef(null);

    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const gridKey = "0BBEBD75-ADAC-4340-B39E-2F150FDFA346";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken, null, currentLayout); }, [currentLayout]);
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);

    const initialFormFields = {
        RItem: null,
        ShipDate: null,
    };
    const [formFields, setformFields] = useState(initialFormFields);
    const onSelectionChanged = ({ selectedRowsData }) => {
        if (selectedRowsData) {
            setSelectedRows(selectedRowsData);
            calculateWeights(selectedRowsData);
        }
    };
    const calculateWeights = (selectedRows) => {
        if (selectedRows) {
            // Assume selectedRows is an array of selected row objects
            let lShipQuantity = 0;
            let lShipWeight = 0;

            selectedRows.forEach(row => {
                lShipQuantity += row.SublotAvailable || 0;
                if (row.WeightBasisFlag === ItemTypes.Item) {
                    lShipWeight += (row.SublotAvailable || 0) * (row.ItemNetWeight || 0);
                } else if (row.WeightBasisFlag === ItemTypes.Lot) {
                    lShipWeight += (row.SublotAvailable || 0) * (row.LotNetWeight || 0);
                } else {
                    lShipWeight += (row.SublotAvailable || 0) * (row.SublotNetWeight || 0);
                }
            });

            if (formRefs.current) {
                formRefs.current['TotalQuantity'].instance().option('value', lShipQuantity);
                formRefs.current['TotalNetWeight'].instance().option('value', lShipWeight);
            }
        }
    }
    const getFreshData = () => {
        let selectedData = selectedRows;
        if (selectedData && selectedData.length > 0) {
            const grid = dataGrid.current.instance();
            const columnName = "SublotAvailable";
            const changes = grid.option("editing.changes");
            selectedData = selectedData.map(row => {
                const change = changes.find(c => c.key === row.SublotRowId);
                if (change && change.data && columnName in change.data) {
                    return {
                        ...row,
                        [columnName]: change.data[columnName]
                    };
                }
                return row;
            });
        }
        return selectedData;
    }

    const handelOkClick = () => {
        const data = getFreshData();
        props.onLotSublotSelect(data);
    };

    const selectionChanged = useCallback(
        (e, tg) => {
            let newItems = [...selectedItems];
            e.removedItems.forEach((item) => {
                const index = newItems.indexOf(item);
                if (index >= 0) {
                    newItems.splice(index, 1);
                }
            });
            if (e.addedItems.length) {
                newItems = [...newItems, ...e.addedItems];
            }
            setSelectedItems(newItems);
            setSearchPanelStatus((prevStatus) => {
                const newStatus = !prevStatus;
                return newStatus;
            });
        },
        [selectedItems, setSelectedItems],
    );

    const handleSearch = (e) => {
        e.event.stopPropagation();
        loadData(formFields);
    }

    const handleReset = (e) => {
        e.event.stopPropagation();
        loadData(initialFormFields);
    }

    useEffect(() => {
        loadData(initialFormFields);
    }, [props.params]);

    const loadData = (fields) => {
        const filters = FillFilters(fields);
        let datasource = loadDatasource();
        datasource.filter(filters);
        setResultData(datasource);
    }
    const loadDatasource = () => {
        let store = createStore({
            key: 'SublotRowId',
            loadUrl: `${window._env_.REACT_APP_APIS}/${data.WMItemLotSublotUnion.GetWMItemsLotSublotUnion}`,
            loadParams:
            {
                ItemRowId: props.params.ItemId,
                ShipDate: props.params.ShipDate,
            },
            sort: [{ selector: "LotCode", desc: false }, { selector: "SublotCode", desc: false }],
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        });

        const dataSource = new DataSource({ store: store });
        return dataSource;
    };

    const handleFormLoad = useCallback(() => {
    }, []);

    const handleFieldChange = useCallback((name, value) => {

    }, []);


    const [resultData, setResultData] = useState(null);


    const handleValueChanged = (e) => {
        console.log(e)
    }

    return (
        <div>
            <div className="row">
                <div className="col-md-12 main-page">
                    <div id="accordion" >
                        <AccordionReact
                            dataSource={searchpanel}
                            collapsible={true}
                            multiple={false}
                            animationDuration={300}
                            selectedItems={selectedItems}
                            onSelectionChanged={e => {
                                if (e.currentTarget === e.target) {
                                    selectionChanged(e, e.target);
                                }
                            }}
                            itemTitleRender={() => (
                                <></>
                            )}
                            itemRender={(itemProps) => (
                                <FormField
                                    currrentUser={currentUser}
                                    layoutId='bf2b0202-6fa8-49b0-91a9-639e9b037b24'
                                    layoutName='WMLotDataEntryHeaderForm'
                                    defaultFormSchema={LotSublotHeaderLayout}
                                    formFields={formFields}
                                    setformFields={setformFields}
                                    handleFieldValueChange={handleFieldChange}
                                    DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                                    formRefs={formRefs}
                                    onFormLoad={handleFormLoad}
                                    noSpacingBeforeFirstRow={true}
                                />
                            )}
                            id="accordion-container" className="accordion-height"
                        />
                        <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                            ref={dataGrid}
                            allowColumnReordering={true}
                            allowColumnResizing={true}
                            dataSource={resultData}
                            showBorders={true}
                            hoverStateEnabled={true}
                            className={"GridHeightAccordianOpen-tabs-single-row"}
                            onSelectionChanged={(e) => onSelectionChanged(e)}
                            remoteOperations={true}
                            searchEnabled={true}
                            columnAutoWidth={true}
                            onEditingStart={(e) => {
                                if (!(e.column.dataField === "SublotAvailable")) {
                                    e.cancel = true;
                                }
                            }}
                        >
                            <ColumnChooser
                                enabled={true}
                                title="Choose Column"
                                width={290}
                                height={290}
                                sortOrder="asc"
                            >
                                <ColumnChooserSearch
                                    enabled={true}
                                    editorOptions={{ placeholder: 'Search column' }} />
                            </ColumnChooser>
                            <Editing
                                mode="batch"
                                allowUpdating={true}
                                allowAdding={false}
                                allowDeleting={false}
                            />
                            <Export enabled={true} allowExportSelectedData={true} />
                            <Selection mode="multiple" />
                            <Sorting visible={true} mode="multiple" />
                            <FilterRow visible={true} />
                            <FilterPanel visible={true} />
                            <GroupPanel visible={true} />
                            <Grouping autoExpandAll={false} />
                            <StateStoring
                                enabled={true}
                                type="custom"
                                customLoad={loadState}
                                storageKey={gridKey}
                                customSave={saveState}
                            />
                            <FilterRow visible={true} />
                            <Column dataField="SublotRowId" caption="Rowid" dataType="string" visible={false} />
                            <Column dataField="LotCode" caption="Lot Code" dataType="string" />
                            <Column dataField="LotDescription1" caption="Lot Description" dataType="string" />
                            <Column dataField="SublotCode" caption="Sublot Code" dataType="string" />
                            <Column dataField="SublotDescription1" caption="Sublot Description" dataType="string" />
                            <Column dataField="SublotAvailable" caption="Ship Quantity" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} allowEditing={true}
                                setCellValue={(newData, value, currentRowData) => {
                                    if (value > currentRowData.NetAvailable) {
                                        alert(MESSAGES.ACTUAL_QUANTITY_GREATER_THEN_AVAILABLE, MESSAGES.ERROR);
                                        return;
                                    }
                                    newData.SublotAvailable = value;
                                    let selectedRowsData = getFreshData();
                                    if(selectedRowsData && selectedRowsData.length >0){
                                      selectedRowsData = selectedRowsData.map(row =>
                                        row.SublotRowId === currentRowData.SublotRowId
                                            ? { ...row, SublotAvailable: value }
                                            : row
                                    );
                                    }
                                    
                                    calculateWeights(selectedRowsData);
                                }} />
                            <Column dataField="NetAvailableSublot" caption="Net Available" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column dataField="OnHandSublot" caption="On Hand" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column dataField="WarehouseIdentityId" caption="Warehouse" dataType="string" />
                            <Column dataField="LocationCode" caption="Location" dataType="string" />
                            <Column dataField="DateAvailableLot" caption="Lot Available Date" dataType="datetime" />
                            <Column dataField="DateExpirationLot" caption="Lot Expiration Date" dataType="datetime" />
                            <Column dataField="SublotConsignee" caption="Consignee" dataType="string" />
                            <Column dataField="ClassCodeLot" caption="Lot Class" dataType="string" />
                            <Column dataField="SubclassCode" caption="Lot SubClass" dataType="string" />

                            <Column visible={false} dataField="NetWeightQuantityLot" caption="Lot Net Weight" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column visible={false} dataField="GrossWeightQuantityLot" caption="Lot Gross Weight" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column visible={false} dataField="WarrantyFlagShipmentItem" caption="Weight Basis Flag" dataType="string" />
                            <Column visible={false} dataField="NetWeightQuantityItem" caption="Item Net Weight" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column visible={false} dataField="GrossWeightQuantityItem" caption="Item Gross Weight" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column visible={false} dataField="TransferQuantity" caption="Transfer Quantity" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column visible={false} dataField="DateAvailableSublot" caption="Sublot Available Date" dataType="datetime" />
                            <Column visible={false} dataField="DateExpirationSublot" caption="Sublot Expiration Date" dataType="datetime" />
                            <Column visible={false} dataField="NetWeightQuantitySublot" caption="Sublot Net Weight" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column visible={false} dataField="GrossWeightQuantitySublot" caption="Sublot Gross Weight" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />

                            <Column visible={false} dataField="Code1Lot" caption="Lot Code 1" dataType="string" />
                            <Column visible={false} dataField="Code2Lot" caption="Lot Code 2" dataType="string" />
                            <Column visible={false} dataField="Code3Lot" caption="Lot Code 3" dataType="string" />
                            <Column visible={false} dataField="Code4Lot" caption="Lot Code 4" dataType="string" />
                            <Column visible={false} dataField="Code5Lot" caption="Lot Code 5" dataType="string" />
                            <Column visible={false} dataField="Code6Lot" caption="Lot Code 6" dataType="string" />
                            <Column visible={false} dataField="Code7Lot" caption="Lot Code 7" dataType="string" />
                            <Column visible={false} dataField="Code8Lot" caption="Lot Code 8" dataType="string" />
                            <Column visible={false} dataField="Code9Lot" caption="Lot Code 9" dataType="string" />
                            <Column visible={false} dataField="Code10Lot" caption="Lot Code 10" dataType="string" />
                            <Column visible={false} dataField="Date1Lot" caption="Lot Date 1" dataType="date" />
                            <Column visible={false} dataField="Date2Lot" caption="Lot Date 2" dataType="date" />
                            <Column visible={false} dataField="Date3Lot" caption="Lot Date 3" dataType="date" />
                            <Column visible={false} dataField="Date4Lot" caption="Lot Date 4" dataType="date" />
                            <Column visible={false} dataField="Date5Lot" caption="Lot Date 5" dataType="date" />
                            <Column visible={false} dataField="Date6Lot" caption="Lot Date 6" dataType="date" />
                            <Column visible={false} dataField="Date7Lot" caption="Lot Date 7" dataType="date" />
                            <Column visible={false} dataField="Date8Lot" caption="Lot Date 8" dataType="date" />
                            <Column visible={false} dataField="Date9Lot" caption="Lot Date 9" dataType="date" />
                            <Column visible={false} dataField="Date10Lot" caption="Lot Date 10" dataType="date" />
                            <Column visible={false} dataField="Quantity1Lot" caption="Lot Quantity 1" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column visible={false} dataField="Quantity2Lot" caption="Lot Quantity 2" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column visible={false} dataField="Quantity3Lot" caption="Lot Quantity 3" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column visible={false} dataField="Quantity4Lot" caption="Lot Quantity 4" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column visible={false} dataField="Quantity5Lot" caption="Lot Quantity 5" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column visible={false} dataField="Quantity6Lot" caption="Lot Quantity 6" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column visible={false} dataField="Quantity7Lot" caption="Lot Quantity 7" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column visible={false} dataField="Quantity8Lot" caption="Lot Quantity 8" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column visible={false} dataField="Quantity9Lot" caption="Lot Quantity 9" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column visible={false} dataField="Quantity10Lot" caption="Lot Quantity 10" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column visible={false} dataField="Reference1Lot" caption="Lot Ref 1" dataType="string" />
                            <Column visible={false} dataField="Reference2Lot" caption="Lot Ref 2" dataType="string" />
                            <Column visible={false} dataField="Reference3Lot" caption="Lot Ref 3" dataType="string" />
                            <Column visible={false} dataField="Reference4Lot" caption="Lot Ref 4" dataType="string" />
                            <Column visible={false} dataField="Reference5Lot" caption="Lot Ref 5" dataType="string" />
                            <Column visible={false} dataField="Reference6Lot" caption="Lot Ref 6" dataType="string" />
                            <Column visible={false} dataField="Reference7Lot" caption="Lot Ref 7" dataType="string" />
                            <Column visible={false} dataField="Reference8Lot" caption="Lot Ref 8" dataType="string" />
                            <Column visible={false} dataField="Reference9Lot" caption="Lot Ref 9" dataType="string" />
                            <Column visible={false} dataField="Reference10Lot" caption="Lot Ref 10" dataType="string" />
                            <Column visible={false} dataField="Code1Sublot" caption="Sublot Code 1" dataType="string" />
                            <Column visible={false} dataField="Code2Sublot" caption="Sublot Code 2" dataType="string" />
                            <Column visible={false} dataField="Code3Sublot" caption="Sublot Code 3" dataType="string" />
                            <Column visible={false} dataField="Code4Sublot" caption="Sublot Code 4" dataType="string" />
                            <Column visible={false} dataField="Code5Sublot" caption="Sublot Code 5" dataType="string" />
                            <Column visible={false} dataField="Code6Sublot" caption="Sublot Code 6" dataType="string" />
                            <Column visible={false} dataField="Code7Sublot" caption="Sublot Code 7" dataType="string" />
                            <Column visible={false} dataField="Code8Sublot" caption="Sublot Code 8" dataType="string" />
                            <Column visible={false} dataField="Code9Sublot" caption="Sublot Code 9" dataType="string" />
                            <Column visible={false} dataField="Code10Sublot" caption="Sublot Code 10" dataType="string" />
                            <Column visible={false} dataField="Date1Sublot" caption="Sublot Date 1" dataType="date" />
                            <Column visible={false} dataField="Date2Sublot" caption="Sublot Date 2" dataType="date" />
                            <Column visible={false} dataField="Date3Sublot" caption="Sublot Date 3" dataType="date" />
                            <Column visible={false} dataField="Date4Sublot" caption="Sublot Date 4" dataType="date" />
                            <Column visible={false} dataField="Date5Sublot" caption="Sublot Date 5" dataType="date" />
                            <Column visible={false} dataField="Date6Sublot" caption="Sublot Date 6" dataType="date" />
                            <Column visible={false} dataField="Date7Sublot" caption="Sublot Date 7" dataType="date" />
                            <Column visible={false} dataField="Date8Sublot" caption="Sublot Date 8" dataType="date" />
                            <Column visible={false} dataField="Date9Sublot" caption="Sublot Date 9" dataType="date" />
                            <Column visible={false} dataField="Date10Sublot" caption="Sublot Date 10" dataType="date" />
                            <Column visible={false} dataField="Quantity1Sublot" caption="Sublot Quantity 1" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column visible={false} dataField="Quantity2Sublot" caption="Sublot Quantity 2" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column visible={false} dataField="Quantity3Sublot" caption="Sublot Quantity 3" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column visible={false} dataField="Quantity4Sublot" caption="Sublot Quantity 4" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column visible={false} dataField="Quantity5Sublot" caption="Sublot Quantity 5" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column visible={false} dataField="Quantity6Sublot" caption="Sublot Quantity 6" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column visible={false} dataField="Quantity7Sublot" caption="Sublot Quantity 7" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column visible={false} dataField="Quantity8Sublot" caption="Sublot Quantity 8" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column visible={false} dataField="Quantity9Sublot" caption="Sublot Quantity 9" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column visible={false} dataField="Quantity10Sublot" caption="Sublot Quantity 10" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                            <Column visible={false} dataField="Reference1Sublot" caption="Sublot Ref 1" dataType="string" />
                            <Column visible={false} dataField="Reference2Sublot" caption="Sublot Ref 2" dataType="string" />
                            <Column visible={false} dataField="Reference3Sublot" caption="Sublot Ref 3" dataType="string" />
                            <Column visible={false} dataField="Reference4Sublot" caption="Sublot Ref 4" dataType="string" />
                            <Column visible={false} dataField="Reference5Sublot" caption="Sublot Ref 5" dataType="string" />
                            <Column visible={false} dataField="Reference6Sublot" caption="Sublot Ref 6" dataType="string" />
                            <Column visible={false} dataField="Reference7Sublot" caption="Sublot Ref 7" dataType="string" />
                            <Column visible={false} dataField="Reference8Sublot" caption="Sublot Ref 8" dataType="string" />
                            <Column visible={false} dataField="Reference9Sublot" caption="Sublot Ref 9" dataType="string" />
                            <Column visible={false} dataField="Reference10Sublot" caption="Sublot Ref 10" dataType="string" />
                            <GridToolbar>
                                <GridToolbarItem location="after">
                                    <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                                </GridToolbarItem>
                                <GridToolbarItem name="exportButton" />
                                <GridToolbarItem name="columnChooserButton" />
                            </GridToolbar>
                        </DataGrid>
                        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                            <Button
                                text="OK"
                                type="default"
                                disabled={!(selectedRows && selectedRows.length > 0)}
                                onClick={handelOkClick}
                                style={{ marginRight: '10px' }}
                            />
                            <Button
                                text="Cancel"
                                onClick={props.onManualItemLotScreenClose}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}
export default connect(mapStateToProps)(LotsSublotForShipment);